import { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  // Estado para controlar si el menú móvil está abierto o cerrado
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = (e) => {
    // Si el elemento cliqueado es un enlace <a> (o está dentro de uno), cerramos el menú
    if (e.target.closest('a')) {
      setIsMenuOpen(false);
    }
  };

  return (
    <header className='header-container'>
      <div id='contenedorMenuFranjaAzul'>
        <div className='franjaAzul'>
        </div>
        <div className='menu' id="menu">
          <div className='logo'>
          </div>

          {/* Botón Hamburguesa (solo visible en móviles) */}
          <button
            className={`hamburger ${isMenuOpen ? 'open' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </button>

          {/* Agregamos la clase 'active' cuando isMenuOpen sea true */}
          <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`} onClick={handleLinkClick}>
            <li className="active"><Link to="/">Inicio</Link></li>

            <li className="dropdown">
              <span>
                Programas
                <span className="arrow">
                  ›
                </span>
              </span>

              <ul className="dropdown-menu">
                <li> <Link to="/formaciontecnicolaboral">Formacion Tecnico Laboral</Link></li>
                <li><Link to="/virtual">Educación Continuada Virtual</Link></li>
                <li><Link to="/diplomados" className='textoColor'>Diplomados</Link></li>
                <li><Link to="/cursos">Cursos</Link></li>
              </ul>
            </li>

            <li><Link to="/galeria">Galería</Link></li>
            <li><Link to="/institucionalidad">Institucionalidad</Link></li>
            <li><Link to="/contacto">Contacto</Link></li>
            <button className='buttonQ10'>
              <a href="https://site.q10.com/login?aplentId=f7bb9af6-4333-4e98-983c-cef7025ecc99" >Ingresar Portal Estudiantil</a>
            </button>
          </ul>
        </div>
      </div>

      <div>
        <div>
        </div>
      </div>

    </header>
  );

}

export default Header;
